'use strict';

require('../../styles/pet/checkout.scss');

var _AttentiveCheckout = require('../components/AttentiveCheckout');

document.addEventListener('page:load', function () {
  if (window.Shopify.Checkout.step == 'thank_you') {
    // Fire Attentive POST to subscribe customer
    (0, _AttentiveCheckout.AttentiveOptin)();
  } else {
    // Add checkbox to opt in to Attentive and set cookie when selected
    (0, _AttentiveCheckout.HandleAttentiveCookie)();
  }
});